import mustache from "mustache";
import {
  fx_createTareaEjecucionRequest,
  TareaEjecucionRequest,
} from "../../../../modulos/rastro/request/TareaEjecucionRequest";
import { TareaEjecucionAsignarTareaRequest } from "../../../../modulos/rastro/request/TareaEjecucionAsignarTareaRequest";
import { TareaEjecucionResponse } from "../../../../modulos/rastro/response/TareaEjecucionResponse";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { formatFechaHoraAnioMesDia } from "../../../../utils/fechaUtils";
import { TareaSelectorField } from "./TareaSelectorField";
import template from "./tareasSinAsignarFormTemplate.html";

mustache.parse(template);

/** Fila del formulario: la ejecución + el request/field propios (uno por
 *  ejecución, independiente de las demás). */
type Fila = {
  ejecucion: TareaEjecucionResponse;
  request: TareaEjecucionRequest;
  field: TareaSelectorField;
};

/** Cuerpo del modal "Tareas sin asignar" (Render/Connect): una fila por
 *  ejecución sin clasificar (ya vienen ordenadas por fecha de inicio
 *  descendente desde `TareaEjecucionDatabase`), cada una con su propio
 *  `TareaSelectorField`. Todas las filas son requeridas — `validate()` exige
 *  tarea en cada una antes de armar `request.asignaciones`. */
export class TareasSinAsignarFormRender implements IFormBodyRender {
  private readonly _filas: Fila[];

  /**
   * @param _request   Request de asignación en masa (lo llena `validate()`).
   * @param ejecuciones Ejecuciones sin clasificar de la finca activa.
   * @param clienteId   Cliente dueño de la finca (catálogo de tareas).
   */
  constructor(
    private readonly _request: TareaEjecucionAsignarTareaRequest,
    ejecuciones: TareaEjecucionResponse[],
    clienteId: string,
  ) {
    this._filas = ejecuciones.map((ejecucion) => {
      const request = fx_createTareaEjecucionRequest(ejecucion);
      return {
        ejecucion,
        request,
        field: new TareaSelectorField(request, clienteId, ejecucion.tareaNombre),
      };
    });
  }

  render(): string {
    return mustache.render(template, {
      filas: this._filas.map(({ ejecucion, field }) => ({
        gpsTrackerNumero: ejecucion.gpsTrackerNumero,
        fechaHora: formatFechaHoraAnioMesDia(ejecucion.fechaInicio),
        selector: field.render(),
      })),
    });
  }

  connect(): void {
    this._filas.forEach(({ field }) => field.connect());
  }

  dispose(): void {
    this._filas.forEach(({ field }) => field.dispose());
  }

  /** Exige tarea en todas las filas (muestra el error de la primera inválida
   *  y le da foco); si todas son válidas, arma `request.asignaciones`. */
  validate(): boolean {
    let isValid = true;
    this._filas.forEach(({ field }) => {
      field.showError();
      if (field.getError()) {
        if (isValid) field.focus();
        isValid = false;
      }
    });
    if (!isValid) return false;

    this._request.asignaciones = this._filas.map(({ request }) => ({
      tareaEjecucionId: request.id,
      tareaId: request.tareaId,
    }));
    return true;
  }
}
